exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header_2lNEQ {\n    width: 100%;\n}\n\n.radioButtonLabel_2w-gi {\n    margin-left: 2px;\n}\n", ""]);

// exports
exports.locals = {
	"header": "header_2lNEQ",
	"radioButtonLabel": "radioButtonLabel_2w-gi"
};